import axios from 'axios';

export type ServicesConfig = {
  baseUrl?: string;
  reqTimeout?: number;
};

class Services {
  private static config: ServicesConfig = {};

  static configure(config: ServicesConfig): void {
    Services.config = {
      ...Services.config,
      ...config
    };
  }

  // Call at the very beginning
  static init(config?: ServicesConfig): void {
    if (config) {
      Services.configure(config);
    }

    if (typeof Services.config.reqTimeout === 'number') {
      axios.defaults.timeout = Services.config.reqTimeout;
    }

    axios.defaults.headers.common['Content-Type'] = 'application/json';

    if (!axios?.defaults?.baseURL && Services.config.baseUrl) {
      axios.defaults.baseURL = Services.config.baseUrl;
    }
  }

  // Call after authentication is done and make required changes
  static initAfterAuth(config: {token: string}): void {
    axios.defaults.headers.common['authorization'] = `Bearer ${
      config?.token || ''
    }`;
  }

  // The generic handling of errors
  static genericErrorHandler(error: any): void {
    if (error && error.response && error.response.data) {
      throw error.response.data;
    } else {
      throw error;
    }
  }
}

export default Services;
